import { css } from '@emotion/react';
export const containerStyle = css `
  display: inline-block;
`;
//# sourceMappingURL=admin-trial-cart.styles.js.map